import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  container: props => ({
    width: props.width,
    height: props.height
  }),
  st0: {
    fill: "#cee0e9"
  },
  st1: {
    fill: "none",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  },
  st2: {
    fill: "#8db8cb",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }
});

const EthiopiaOutlineIcon = props => {
  const classes = useStyles(props);

  return (
    <SvgIcon
      viewBox="0 0 80 80"
      className={classNames(classes.container, props.className)}
    >
      <path
        className={classes.st0}
        d="M61.7,22.1L52,9.2L40.6,0H0v80h66l14-14.7V16.8L61.7,22.1z M61.8,58.4h-7.4l-5,2.5h-2.5v2.5h-5v-2.5l-5,2.5v2.5
	h-7.3v-2.5h-2.5l-5-2.5h-2.5l-2.5-5h-2.5l-5-9.9l-2.5-2.5H4.9v-5h5v-9.9h2.5l5-9.9l2.5-7.4h5l2.5-2.5h2.2v2.5h9.9l7.4,9.9l-2.5,5
	v2.5h7.4v5l5,5l12.4,5h7.4L61.8,58.4z"
      />
      <polyline
        className={classes.st1}
        points="80,16.8 61.7,22.1 52,9.2 40.6,0 "
      />
      <line className={classes.st1} x1="66" y1="80" x2="80" y2="65.3" />
      <polygon
        className={classes.st2}
        points="69.3,43.5 56.9,38.5 51.9,33.6 51.9,28.6 44.5,28.6 44.5,26.2 47,21.2 39.5,11.3 29.6,11.3 29.6,8.8 
	27.2,8.8 24.7,11.3 19.7,11.3 17.3,18.7 12.3,28.6 9.8,28.6 9.8,38.5 4.9,38.5 4.9,43.5 7.3,43.5 9.8,46 14.8,55.9 17.3,55.9 
	19.7,60.8 22.2,60.8 27.2,63.3 29.6,63.3 29.6,65.8 37.1,65.8 37.1,63.3 42,60.8 42,63.3 47,63.3 47,60.8 49.4,60.8 54.4,58.4 
	61.8,58.4 76.7,43.5 "
      />
    </SvgIcon>
  );
};

EthiopiaOutlineIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

export default EthiopiaOutlineIcon;
